import type { FormEvent, ReactNode } from "react";
import Button from "ui/buttons/Button";
import Modal from "ui/components/Modal";

interface ConfirmModalProps {
  open: boolean;
  onClose: () => any;
  onConfirm: (e: FormEvent<HTMLFormElement>) => Promise<void> | void;
  title: string;
  message: ReactNode;
  isLoading?: boolean;
}

export default function ConfirmModal({ open, onClose, onConfirm, title, message, isLoading }: ConfirmModalProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      size="small"
      title={title}
      footer={
        <>
          <Button btnSize="large" type="button" btnStyle="tertiary" onClick={handleClose}>
            Cancel
          </Button>
          <form onSubmit={onConfirm}>
            <Button btnSize="large" type="submit" disabled={isLoading}>
              Confirm
            </Button>
          </form>
        </>
      }
      variants={["bodyPadding", "footerButtons"]}
    >
      <form>{message}</form>
    </Modal>
  );
}
